var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import * as React from 'react';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { EGDSText } from '@egds/react-core/text';
import { EGDSPrimaryButton, EGDSTertiaryButton } from '@egds/react-core/button';
import { ClickTracker } from 'bernie-analytics';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { HeaderRegion } from './templates/header-elements/header-region';
var BSABanner = /** @class */function (_super) {
  __extends(BSABanner, _super);
  function BSABanner() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  BSABanner.prototype.render = function () {
    var bsa = this.props.bsa;
    var Button = ClickTracker(EGDSPrimaryButton);
    var bannerText = '';
    var bannerSubText = '';
    var bannerButton = null;
    var bannerSecondaryText = '';
    var bannerLink = null;
    (bsa.sectionData || []).forEach(function (item) {
      switch (item.id) {
        case 'text':
          bannerText = item.text;
          break;
        case 'subText':
          bannerSubText = item.text;
          break;
        case 'button':
          bannerButton = item;
          break;
        case 'secondaryText':
          bannerSecondaryText = item.text;
          break;
        case 'link':
          bannerLink = item;
          break;
        default:
          break;
      }
    });
    return React.createElement(HeaderRegion, {
      className: "page-header no-stripe bsa-background-color"
    }, React.createElement(EGDSSpacing, {
      padding: {
        inline: 'six'
      },
      margin: {
        block: 'six'
      }
    }, React.createElement("div", {
      className: "site-header global_navigation__header__default__max_width"
    }, React.createElement(EGDSLayoutFlexItem, {
      grow: 1
    }, React.createElement(EGDSLayoutFlex, {
      justifyContent: "space-between"
    }, React.createElement(EGDSLayoutFlexItem, null, React.createElement("div", null, React.createElement(EGDSText, {
      size: 300,
      weight: "medium"
    }, bannerText + ((bannerSecondaryText === null || bannerSecondaryText === void 0 ? void 0 : bannerSecondaryText.length) > 0 ? " (".concat(bannerSecondaryText, ")") : '')), React.createElement(EGDSText, {
      size: 300,
      weight: "bold"
    }, bannerSubText))), React.createElement("div", null, React.createElement(EGDSLayoutFlexItem, null, bannerLink && React.createElement(EGDSTertiaryButton, {
      className: "global-navigation-nav-button",
      href: bannerLink.url
    }, React.createElement(EGDSText, {
      size: 300
    }, bannerLink.text))), React.createElement(EGDSLayoutFlexItem, null, bannerButton && React.createElement(Button, {
      id: bannerButton.id,
      rfrr: bannerButton.trackingEvent,
      linkName: bannerButton.trackingEvent,
      href: bannerButton.url,
      trackImmediate: true
    }, bannerButton.text))))))));
  };
  return BSABanner;
}(React.PureComponent);
export { BSABanner };